import { Info, Sparkle, Warning } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import { EmptyState } from '@/components/empty-state';
import { cn } from '@/lib/cn';

export const REVIEW_NOTICE = 'Revise antes de usar: a IA pode errar. Nada é enviado automaticamente.';
export const SEARCH_NOTICE = 'Não digite dados pessoais. A IA não inventa marca, tamanho nem estado de conservação.';

/** Estado honesto: sem o recurso disponível nada é simulado e nenhuma ação fica habilitada. */
export function AiUnavailable() {
  return (
    <EmptyState
      bare
      icon={Sparkle}
      title="Assistente indisponível"
      description="O assistente de IA não está disponível no momento. Fale com o suporte."
    />
  );
}

export function Notice({ tone = 'info', children, id, className }: { tone?: 'info' | 'warning' | 'danger'; children: ReactNode; id?: string; className?: string }) {
  const Icon = tone === 'info' ? Info : Warning;
  return (
    <div
      id={id}
      className={cn(
        'flex items-start gap-2.5 rounded-control px-3 py-2.5 text-sm',
        tone === 'info' && 'bg-sand text-sand-foreground',
        tone === 'warning' && 'bg-warning-soft text-warning',
        tone === 'danger' && 'bg-destructive-soft text-destructive',
        className,
      )}
    >
      <Icon className="mt-0.5 size-4 shrink-0" weight="bold" aria-hidden />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}

export function Disclaimers({ items }: { items: string[] }) {
  if (items.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1.5" aria-label="Avisos">
      {items.map((d) => (
        <li key={d}>
          <Notice>{d}</Notice>
        </li>
      ))}
    </ul>
  );
}

export const textareaClasses =
  'min-h-28 w-full resize-y rounded-control border border-input bg-card px-3 py-2.5 text-sm text-foreground placeholder:text-muted-foreground/80 transition-colors hover:border-foreground/50 focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-0 disabled:opacity-70 aria-[invalid=true]:border-destructive';
